module.exports = __webpack_public_path__ + "img/login-jveventosdeportivos.17b5bbb7.svg";